import Axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { url } from 'utils/url';
import { log, errorMsg } from 'utils';

export const SCHEDULE_FETCH_DATA_INIT = createAction('SCHEDULE_FETCH_DATA_INIT');
export const SCHEDULE_FETCH_DATA_SUCCESS = createAction('SCHEDULE_FETCH_DATA_SUCCESS');
export const SCHEDULE_FETCH_DATA_FAIL = createAction('SCHEDULE_FETCH_DATA_FAIL');

export const SCHEDULE_DELETE_INIT = createAction('SCHEDULE_DELETE_INIT');
export const SCHEDULE_DELETE_SUCCESS = createAction('SCHEDULE_DELETE_SUCCESS');
export const SCHEDULE_DELETE_FAIL = createAction('SCHEDULE_DELETE_FAIL');

export const SCHEDULE_CREATE_INIT = createAction('SCHEDULE_CREATE_INIT');
export const SCHEDULE_CREATE_SUCCESS = createAction('SCHEDULE_CREATE_SUCCESS');
export const SCHEDULE_CREATE_FAIL = createAction('SCHEDULE_CREATE_FAIL');

export const SCHEDULE_MODIFY_INIT = createAction('SCHEDULE_MODIFY_INIT');
export const SCHEDULE_MODIFY_SUCCESS = createAction('SCHEDULE_MODIFY_SUCCESS');
export const SCHEDULE_MODIFY_FAIL = createAction('SCHEDULE_MODIFY_FAIL');

export const SCHEDULE_CLEAN_UP = createAction('SCHEDULE_CLEAN_UP');
export const SCHEDULE_CLEAR_DATA_LOGOUT = createAction('SCHEDULE_CLEAR_DATA_LOGOUT');
export const SET_SCHEDULE = createAction('SET_SCHEDULE');

export const fetchSchedule = ({ siteId, scheduleId }) => {
  return async (dispatch, getState) => {
    dispatch(SCHEDULE_FETCH_DATA_INIT());

    if (scheduleId) {
      let scheduleData;
      try {
        scheduleData = await Axios.get(`${url}/schedule/${scheduleId}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
        });
      } catch (error) {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(SCHEDULE_FETCH_DATA_FAIL({ error }));
      }
      const schedule = scheduleData.data?.data || scheduleData.data;
      return dispatch(
        SCHEDULE_FETCH_DATA_SUCCESS({
          list: getState().schedule.list,
          schedule,
        })
      );
    }

    if (siteId) {
      let res;
      try {
        res = await Axios.get(`${url}/schedule/`, {
          params: { siteId },
          headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
        });
      } catch (error) {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(SCHEDULE_FETCH_DATA_FAIL({ error }));
      }

      const raw = res.data?.data || [];
      const list = Array.isArray(raw)
        ? raw.filter((s) => !siteId || s.siteId === siteId)
        : [];

      return dispatch(
        SCHEDULE_FETCH_DATA_SUCCESS({
          list,
          schedule: getState().schedule.schedule,
        })
      );
    }
  };
};

export const deleteSchedule = ({ id, siteId }, cb) => {
  return async (dispatch) => {
    dispatch(SCHEDULE_DELETE_INIT());
    try {
      await Axios.delete(`${url}/schedule/delete`, {
        params: { id, siteId },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      const errorMessage = error?.response?.data?.message || 'Delete failed';
      toastr.error('', errorMessage);
      return dispatch(SCHEDULE_DELETE_FAIL({ error: errorMessage }));
    }
    toastr.success('', 'Schedule deleted.');
    if (cb) cb();
    return dispatch(SCHEDULE_DELETE_SUCCESS({ id }));
  };
};

export const createSchedule = (payload, setIsModalShow, onConflict) => {
  return async (dispatch) => {
    dispatch(SCHEDULE_CREATE_INIT());
    let created;
    try {
      created = await Axios.post(`${url}/schedule/create`, payload, {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      });
      log(created, '<<< created schedule');
    } catch (error) {
      const body = error?.response?.data;
      const errorMessage = body?.message || 'Create failed';
      if (error?.response?.status === 409 && onConflict) onConflict(body);
      else toastr.error('', errorMessage);
      return dispatch(SCHEDULE_CREATE_FAIL({ error: body || error }));
    }
    toastr.success('', 'Schedule created successfully');
    if (setIsModalShow) setIsModalShow(false);
    dispatch(fetchSchedule({ siteId: payload.siteId }));
    return dispatch(
      SCHEDULE_CREATE_SUCCESS({ schedule: created.data?.data })
    );
  };
};

export const modifySchedule = (payload, setIsModalShow, onConflict, opts = {}) => {
  return async (dispatch) => {
    dispatch(SCHEDULE_MODIFY_INIT());
    try {
      await Axios.post(`${url}/schedule/edit`, payload, {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      });
    } catch (error) {
      const body = error?.response?.data;
      const errorMessage = body?.message || 'Update failed';
      if (error?.response?.status === 409 && onConflict) onConflict(body);
      else if (!opts.silent) toastr.error('', errorMessage);
      dispatch(SCHEDULE_MODIFY_FAIL({ error: body || error }));
      const err = new Error(errorMessage);
      err.body = body;
      err.status = error?.response?.status;
      throw err;
    }
    if (!opts.silent) toastr.success('', 'Schedule updated successfully');
    if (setIsModalShow) setIsModalShow(false);
    if (!opts.skipRefetch) dispatch(fetchSchedule({ siteId: payload.siteId }));
    return dispatch(SCHEDULE_MODIFY_SUCCESS({ id: payload.id }));
  };
};

export const scheduleCleanUp = () => (dispatch) => dispatch(SCHEDULE_CLEAN_UP());

export const setSchedule = (data) => (dispatch) =>
  dispatch(SET_SCHEDULE({ data }));

export const fetchScheduleTimeline = async ({ siteId, screenIds }) => {
  const res = await Axios.post(
    `${url}/schedule/timeline`,
    { siteId, screenIds },
    { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
  );
  return res.data?.data || [];
};